import type { RouteLocationRaw } from 'vue-router';
import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const LinkTarget = {
  Self: '_self',
  Blank: '_blank',
  Parent: '_parent',
  Top: '_top',
} as const;

export type LinkTargetType = (typeof LinkTarget)[keyof typeof LinkTarget];

export const LinkVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
} as const;

export type LinkVariantType = (typeof LinkVariant)[keyof typeof LinkVariant];

export type LinkProps = {
  label?: string;
  to?: RouteLocationRaw;
  href?: string;
  target?: LinkTargetType;
  variant?: LinkVariantType;
  iconLeft?: TUNDR_ICONS;
  iconRight?: TUNDR_ICONS;
  disabled?: boolean;
  testId?: string;
};

export type LinkEmits = {
  click: [event: MouseEvent | KeyboardEvent];
};

export type LinkSlots = {
  default?: () => unknown;
};
